// §4.4 partial — the /trade route. Composer auto-collects this into
// routes.generated.ts. The Component wrapper is a TSX file; we expose it
// here because partials must keep the `.ts` filename pattern the composer
// globs for.
import { lazyWithRetry } from "@/lib/lazy/lazyWithRetry";
import type { RouteObject } from "react-router-dom";

const TradeRoute = lazyWithRetry(() => import("./components/TradeRoute"));

const routes: RouteObject[] = [
  {
    path: "/trade",
    Component: TradeRoute,
  },
];

export default routes;
